import React from 'react';
import { Alert, Button, Checkbox, Chip, Col, Colors, Content, Div, Divider, Input, Label, Row, SearchInput, Spacer, Tooltip } from '@gower/react-ui/components';
import { RoutesEnum } from 'app/routes';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../store';
import { DataGrid, DataGridColumn, DataGridRef } from '@gower/react-ui/template/data-grid';
import { AiOutlineMedicineBox, AiOutlineUser } from '@gower/react-ui/icons';

export const AuthorizationsMobile = () => {

    const navigate = useNavigate();
    const store = useStore();
    const gridRef = React.useRef<DataGridRef>();

    function open ( authId: string ) {
        navigate( `${ RoutesEnum.Authorizations }/${ authId }` );
    }

    function search ( text: string ) {
        gridRef?.current?.search( text );
    }

    return <>
        <Content start columns noScroll>
            <Col
                fullWidth
                padding={10}
            >
                <SearchInput
                    placeholder="Buscar una autorización"
                    borderless
                    onSearch={search}
                    disabled={store.Status.isLoading}
                    clearable
                />
            </Col>

            <Spacer vertical scroll white>
                <DataGrid
                    ref={gridRef}
                    store={store}
                    loading={store.Status.isLoading}
                    showFilters={["status", "agreement", "effector_license", "billing_license", "date_range"]}
                    mobileTemplate={( { data } ) => (
                        <Row
                            white
                            center
                            borderRadius={5}
                            padding={5}
                            activeEffect
                            noWrap
                            onClick={() => open( data.Id )}
                        >
                            <Col
                                stretch
                                width={4}
                                color="surface-2"
                            />
                            <Spacer center gutter paddingX={8} ellipsis>
                                <Row columns>
                                    <Col>
                                        <Label p xxsmall bold show={!!data.AuthorizationId}>
                                            #{data.AuthorizationId}
                                        </Label>
                                        <Label p xxsmall bold show={!data.AuthorizationId && !!data.ReferenceId}>
                                            #{data.ReferenceId} (ref. provisional)
                                        </Label>
                                        <Label p xxsmall bold show={!data.AuthorizationId && !data.ReferenceId && !!data.LocalId}>
                                            #{data.LocalId} (provisional)
                                        </Label>
                                    </Col>
                                    <Col>
                                        <Col center horizontalGutter>
                                            <AiOutlineUser />
                                        </Col>
                                        <Col center horizontalGutter>
                                            <Label p show={!!data.Affiliate?.Id}>
                                                <Label xxsmall label={data.Affiliate?.Id} />
                                                <Label gutter xsmall label={data.Affiliate?.Name} />
                                            </Label>
                                            <Label p hidden={!!data.EffectorProfessional?.Id}>
                                                <Label xsmall textGrey label="S/D" />
                                            </Label>
                                        </Col>
                                    </Col>
                                    <Col>
                                        <Col center horizontalGutter>
                                            <AiOutlineMedicineBox />
                                        </Col>
                                        <Col center horizontalGutter>
                                            <Label p show={!!data.EffectorProfessional?.Id}>
                                                <Label xxsmall label={data.EffectorProfessional?.Id} />
                                                <Label gutter xsmall label={data.EffectorProfessional?.Name} />
                                            </Label>
                                            <Label p hidden={!!data.EffectorProfessional?.Id}>
                                                <Label xsmall textGrey label="S/D" />
                                            </Label>
                                        </Col>
                                    </Col>
                                </Row>
                            </Spacer>
                            <Col center gutter>
                                <Div textRight>
                                    <Label p xsmall label={data.AuthorizationDate.toStringDate( 'short', true )} />
                                    <Label p xsmall label={data.Agreement.Description} />
                                    <Label p xxsmall
                                        xsmall
                                        textRed={data.Status.isReject || data.Status.isErrored || data.Status.isCanceled}
                                        textGreen={data.Status.isAccepted}
                                        label={data.Status.Description} />
                                </Div>
                            </Col>
                        </Row>
                    )}
                >
                    <DataGridColumn
                        field="LocalId"
                        title="Nº de Autorización"
                        size={80}
                        minSize={50}
                        template={( { data } ) => (
                            <Div block>
                                <Label p >
                                    #{data.LocalId}
                                </Label>
                            </Div>
                        )}
                    />
                </DataGrid>
            </Spacer>

        </Content>
    </>;
};

